import React from 'react';
import delIcon from '../../../assets/icons/new_icon/delete-2.svg';
import CountriesSelect from '../../global-components/countriesSelect';

interface Props {
  data: any;
  deleteCommodity: any;
  index: any;
  updateCommodity: any;
}

const ComodityFields: React.FC<Props> = ({
  data,
  deleteCommodity,
  index,
  updateCommodity,
}: Props) => {
  return (
    <div id={`p_${data?.package_id}_commodities_list`}>
      <div
        className={`d-flex gap-3 w-100 mt-2 p_${data?.package_id}_${index}_commodity`}
      >
        <div className=''>
          <label
            className='fw-bold d-flex'
            htmlFor={`p_${data?.package_id}_${index}_commodity_qty`}
          >
            Quantity{' '}
            <span className='text-danger fw-bold' style={{ marginLeft: '2px' }}>
              *
            </span>
          </label>
          <input
            className='form-control ubbe-input pt-2'
            id={`p_${data?.package_id}_${index}_commodity_qty`}
            placeholder='Ex: 1'
            value={data?.quantity}
            maxLength={10}
            onChange={(e) => {
              updateCommodity({
                ...data,
                quantity: e.target.value.replace(/[^0-9]/g, ''),
                validations: {
                  ...data.validations,
                  quantity: e.target.value !== '',
                },
              });
            }}
          />
        </div>
        <div className=''>
          <label
            className='fw-bold'
            htmlFor={`p_${data?.package_id}_${index}_commodity_description`}
          >
            Description{' '}
            <span className='text-danger fw-bold' style={{ marginLeft: '2px' }}>
              *
            </span>
          </label>
          <input
            className='form-control ubbe-input pt-2'
            id={`p_${data?.package_id}_${index}_commodity_description`}
            placeholder='Description of the Good'
            maxLength={40}
            value={data?.description}
            onChange={(e) => {
              updateCommodity({
                ...data,
                description: e.target.value,
                validations: {
                  ...data.validations,
                  description: e.target.value !== '',
                },
              });
            }}
          />
        </div>
        <div className=''>
          <label
            className='fw-bold'
            htmlFor={`p_${data?.package_id}_${index}_commodity_country`}
          >
            Country of Origin{' '}
            <span className='text-danger fw-bold' style={{ marginLeft: '2px' }}>
              *
            </span>
          </label>
          <CountriesSelect
            onSelect={(val: any) => {
              updateCommodity({
                ...data,
                made_in_country_code: val,
                validations: {
                  ...data.validations,
                  made_in_country_code: val !== '',
                },
              });
            }}
            selectedCountry={data?.made_in_country_code}
          />
        </div>
        <div className=''>
          <label
            className='fw-bold'
            htmlFor={`p_${data?.package_id}_${index}_commodity_value`}
          >
            Value of Good{' '}
            <span className='text-danger fw-bold' style={{ marginLeft: '2px' }}>
              *
            </span>
          </label>
          <input
            className='form-control ubbe-input pt-2'
            id={`p_${data?.package_id}_${index}_commodity_value`}
            placeholder='Value of Good'
            value={data?.unit_value}
            maxLength={30}
            onChange={(e) => {
              const inputValue = e.target.value;
              const isValidInput = /^\d+(\.\d{0,2})?$/.test(inputValue);

              if (isValidInput || inputValue === '') {
                updateCommodity({
                  ...data,
                  unit_value: inputValue,
                  validations: {
                    ...data.validations,
                    unit_value: inputValue !== '',
                  },
                });
              }
            }}
          />
        </div>
        <div className=''>
          <label
            className='fw-bold'
            htmlFor={`p_${data?.package_id}_${index}_commodity_weight`}
          >
            Weight{' '}
            <span className='text-danger fw-bold' style={{ marginLeft: '2px' }}>
              *
            </span>
          </label>
          <input
            className='form-control ubbe-input pt-2'
            id={`p_${data?.package_id}_${index}_commodity_weight`}
            placeholder='999,999'
            value={data?.total_weight}
            maxLength={9}
            onChange={(e) => {
              const inputValue = e.target.value;
              const isValidInput = /^\d+(\.\d{0,2})?$/.test(inputValue);

              if (isValidInput || inputValue === '') {
                updateCommodity({
                  ...data,
                  total_weight: inputValue,
                  validations: {
                    ...data.validations,
                    total_weight: inputValue !== '',
                  },
                });
              }
            }}
          />
        </div>
        <div className=' mt-auto mb-2'>
          <button
            className='btn-ubbe-no-style'
            onClick={() => deleteCommodity()}
          >
            <img
              alt='delete-icon'
              src={delIcon}
              className='packageBoxIcon'
              style={{
                backgroundColor: 'rgba(252, 0, 0, 0.10)',
              }}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComodityFields;
